<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header" *ngIf="ratePlan">
                <h5 class="modal-title">{{ratePlan.name}}</h5>
                <a class="close hover" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">
                <div class="modal-body">

                    <ng-container *ngIf="rp">
                    <h2 class="mat-title mb-4">{{rp.additionalNightsTitle}}</h2>
                        <div [innerHTML]="rp.additionalNightsSubtitle"></div>
                        <!-- <p>Stay an extra night and we'll discount that night by {{rp.additionalNightDiscount | number: '1.0-0'}}%</p>
                        <p>Your additional night will be discounted by {{rp.additionalNightDiscount | number: '1.0-0'}}%</p> -->
                    <!-- <p>Was: </p> -->
                    <p class="section-title mb-4">{{av.nights}} nights total <span class="was">
                        {{rp.costs.costPassport.trueCostOfStay | currency: 'GBP'}}</span> {{rp.costs.costPassport.costOfStay | currency: 'GBP'}}
                    </p>

                    <div class="mb-4">
                        <p class="mb-0" *ngFor="let n of rp.nights; let i = index">
                            <span *ngIf="+n.costPassport.trueCostPerNight <= +n.costPassport.costPerNight">Night {{i+1}}: {{n.costPassport.costPerNight | currency: 'GBP'}}</span>
                            <span *ngIf="+n.costPassport.trueCostPerNight > +n.costPassport.costPerNight">Night {{i+1}}: <span class="was">{{n.costPassport.trueCostPerNight | currency: 'GBP'}}</span> now {{n.costPerNight | currency: 'GBP'}}</span>
                        </p>
                    </div>

                    <!-- <ng-container *ngIf="options.length">
                        <h2 class="mat-title mb-1">Please select one of the following options</h2>
                        <div class="option-box">
                            <ul class="list-group">
                                <li
                                    class="list-group-item d-flex"
                                    *ngFor="let o of options; let idx = index"
                                    (click)="toggleOptionSelected(idx)"
                                    [ngClass]="{'active' : o.selected}">
                                    {{o.text}}
                                    <i *ngIf="o.selected" class="fa fa-check-circle text-success ml-auto"></i>
                                </li>
                            </ul>
                        </div>

                    </ng-container> -->
                    <p class="text-danger mt-2 mb-2" *ngIf="errorText">{{errorText}}</p>
                    <div class="row mb-4">
                        <div class="col-6">
                            <button class="btn btn-warning" (click)="cancel()">No thanks</button>
                        </div>
                        <div class="col-6 text-right">
                            <button class="btn btn-primary" (click)="accept()">Add additional night</button>
                        </div>
                    </div>

                            <!-- <p class="section-subtitle font-light mb-2 mt-4">Terms and conditions</p>

                            <div [innerHTML]="rp.terms"></div> -->

                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show modal-slide-show"></div>
